var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "86ba2a98614c01e46456ef284d10d5db2d63f55d"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["www-ligonier-org@ligonier"] = {
  id: "86ba2a98614c01e46456ef284d10d5db2d63f55d"
};